export enum DemoDayQueryKeys {
  GET_DEMO_DAY_STATE = 'GET_DEMO_DAY_STATE',
  GET_FUNDRAISING_PROFILE = 'GET_FUNDRAISING_PROFILE',
  GET_TEAMS_LIST = 'GET_TEAMS_LIST',
  GET_ALL_FUNDRAISING_PROFILES = 'GET_ALL_FUNDRAISING_PROFILES',
  GET_ENGAGEMENT = 'GET_ENGAGEMENT',
  GET_DEMO_DAY_STATS = 'GET_DEMO_DAY_STATS',
  GET_DEMO_DAYS_LIST = 'GET_DEMO_DAYS_LIST',
  GET_TEAM_FUNDRAISING_PROFILE = 'GET_TEAM_FUNDRAISING_PROFILE',
  GET_DEMO_DAY_REPORT_LINK = 'GET_DEMO_DAY_REPORT_LINK',
}
